import api from './api';

const aiAgentService = {
  getAgentProfile: async () => {
    return await api.get('/ai-agent/profile');
  },
  
  sendMessage: async (message) => {
    return await api.post('/ai-agent/message', { message });
  },
  
  updateAgentSettings: async (settings) => {
    return await api.put('/ai-agent/settings', settings);
  },
  
  getConversationHistory: async () => {
    return await api.get('/ai-agent/conversation-history');
  },

  recommendAvatar: async () => {
    return await api.post('/ai-agent/recommend-avatar');
  }
};

export default aiAgentService;
